import _ from 'lodash'
import localForage from 'localforage'

import BaseStore from 'api/Base'
import {AuthConstants} from 'api/auth'
import {Actions as NetworkActions} from 'api/network/Constants'

import Service from './Service'
import {Actions} from './Constants'

class ChannelStore extends BaseStore {
   constructor() {
      super()

      this.subscribe(this._subscribe.bind(this))

      this._channels = []
      this._tokens = []
   }

   emitChange() {
      localForage.setItem('channels', this._channels).then(() => {
         BaseStore.prototype.emitChange.call(this)
      })
   }

   updateOrReplace(nid, key, data) {
      const idx = _.findIndex(this._channels, {key: key, network: nid})

      if (-1 === idx) {
         this._channels.push(data)
      } else {
         this._channels[idx] = data
      }
   }

   maybeUpdate(nid, key, data) {
      const idx = _.findIndex(this._channels, {key: key, network: nid})

      if (-1 === idx) {
         return false
      } else {
         this._channels[idx] = data

         return true
      }
   }

   updateOrReplaceToken(nid, channel, token, data) {
      const idx = _.findIndex(this._tokens, {
         key:   token,
         owner: `channel/${nid}/${channel}`
      })

      if (-1 === idx) {
         this._tokens.push(data)
      } else {
         this._tokens[idx] = data
      }
   }

   maybeUpdateToken(nid, channel, token, data) {
      const idx = _.findIndex(this._tokens, {
         key:   token,
         owner: `channel/${nid}/${channel}`
      })

      if (-1 === idx) {
         return false
      } else {
         this._tokens[idx] = data

         return true
      }
   }

   _subscribe(action) {
      let idx

      switch (action.actionType) {
         case AuthConstants.Actions.logout:
            this._channels = null
            localForage.removeItem('channels')
            this.emitChange()
            break

         case Actions.create:
            this.updateOrReplace(action.nid, action.key, action.channel)
            this.emitChange()
            break

         case Actions.update:
            if (this.maybeUpdate(action.nid, action.key, action.channel)) {
               this.emitChange()
            }
            break

         case Actions.list:
            _.each(action.channels, chan => this.updateOrReplace(action.nid, chan.key, chan))
            this.emitChange()
            break

         case Actions.change:
            if (this.maybeUpdate(action.nid, action.key, action.channel)) {
               this.emitChange()
            }
            break
         // not implemented
         case Actions.io_recv:
            break
         // not implemented
         case Actions.io_send:
            break

         case Actions.token_create:
            this.updateOrReplaceToken(action.nid, action.channel, action.token.key, action.token)
            this.emitChange()
            break

         case Actions.token_list:
            _.each(action.tokens, token =>
               this.updateOrReplaceToken(action.nid, action.channel, token.key, token)
            )
            this.emitChange()
            break

            if (this.maybeUpdateToken(action.nid, action.channel, action.token.key, action.token)) {
               this.emitChange()
            }
            break

         case Actions.token_revoke:
         case Actions.token_change:
            if (this.maybeUpdateToken(action.nid, action.channel, action.token.key, action.token)) {
               this.emitChange()
            }
            break
      }
   }

   channels(nid) {
      return _.where(this._channels, {network: nid})
   }

   channel(nid, channel) {
      return _.where(this._channels, {network: nid, key: channel})[0]
   }

   tokens(nid, channel) {
      return _.where(this._tokens, {owner: `channel/${nid}/${chan}`})
   }

   token(nid, channel, token) {
      return _.where(this._tokens, {owner: `channel/${nid}/${chan}`, key: token})[0]
   }
}

export default new ChannelStore()



// WEBPACK FOOTER //
// lib/api/channel/Store.js